import React, { useState, useEffect } from "react";
import { weddingImages } from "../data/weddingImages";
import Grommet from "./Grommet";
import ribbonImage from "../assets/ribbon-removebg-preview.png";

function RibbonDivider() {
  const [displayedImages, setDisplayedImages] = useState([]);
  const [imageAspectRatios, setImageAspectRatios] = useState({});

  useEffect(() => {
    // Get 1 random image from the weddingImages array
    const shuffled = [...weddingImages].sort(() => 0.5 - Math.random());
    const selected = shuffled.slice(0, 1);
    setDisplayedImages(selected);
  }, []);

  const handleImageLoad = (index, event) => {
    const { naturalWidth, naturalHeight } = event.target;
    const aspectRatio = naturalWidth / naturalHeight;
    console.log(
      `Image ${index}: ${naturalWidth}x${naturalHeight}, aspect ratio: ${aspectRatio.toFixed(
        2
      )}`
    );
    setImageAspectRatios((prev) => ({
      ...prev,
      [index]: aspectRatio,
    }));
  };

  const getMarginTop = (index) => {
    const aspectRatio = imageAspectRatios[index];
    const screenWidth = window.innerWidth;
    const isMobile = screenWidth <= 393;
    const isTablet = screenWidth <= 440;

    if (!aspectRatio) {
      let defaultMargin;
      if (isMobile) defaultMargin = "-2.85rem";
      else if (isTablet) defaultMargin = "-2.85rem";
      else defaultMargin = "-2rem";

      console.log(
        `Image ${index}: Not loaded yet, using default margin ${defaultMargin}`
      );
      return defaultMargin;
    }

    let margin;
    if (aspectRatio <= 0.75) {
      if (isMobile) margin = "-1.5rem";
      else if (isTablet) margin = "-1.95rem";
      else margin = "-3rem";
    } else {
      if (isMobile) margin = "-2.85rem";
      else if (isTablet) margin = "-0.47rem";
      else margin = "-0.5rem";
    }
    console.log(
      `Image ${index}: Aspect ratio ${aspectRatio.toFixed(
        2
      )}, width: ${screenWidth}, applying margin: ${margin}`
    );
    return margin;
  };

  const getItemStyle = () => ({
    display: "inline-block",
    transition: "all 0.35s",
    transform: "scale(0.8, 0.8) rotate(5deg)",
  });

  const getPolaroidStyle = () => ({
    background: "#fff",
    padding: "1rem 1rem 1rem 1rem",
    borderTop: "2px solid #fff",
    borderLeft: "2px solid #fff",
    borderRight: "2px solid #fff",
    borderBottom: "48px solid #fff",
    boxShadow: "0 0.25rem 1rem rgba(0,0,0,0.2)",
    position: "relative",
    display: "inline-block",
  });

  const getImageStyle = () => ({
    maxWidth: "100%",
    height: "auto",
    display: "block",
  });

  const getCaptionStyle = () => ({
    fontSize: "1.125rem",
    textAlign: "center",
    lineHeight: "2em",
    marginTop: "0.5rem",
  });

  const getShadowStyle = (index) => {
    const shadows = [
      {
        transform: "rotate(6deg)",
        height: "20%",
        width: "47%",
        bottom: "30px",
        right: "12px",
        boxShadow: "0 2.1rem 2rem rgba(0,0,0,0.4)",
      },
      {
        transform: "rotate(-6deg)",
        height: "20%",
        width: "47%",
        bottom: "30px",
        left: "12px",
        boxShadow: "0 2.1rem 2rem rgba(0,0,0,0.4)",
      },
      {
        transform: "rotate(4deg)",
        height: "20%",
        width: "47%",
        bottom: "30px",
        right: "12px",
        boxShadow: "0 2.1rem 2rem rgba(0,0,0,0.3)",
      },
      {
        transform: "rotate(-4deg)",
        height: "20%",
        width: "47%",
        bottom: "30px",
        left: "12px",
        boxShadow: "0 2.1rem 2rem rgba(0,0,0,0.3)",
      },
    ];
    return {
      position: "absolute",
      zIndex: -1,
      transition: "all 0.35s",
      ...shadows[index % shadows.length],
    };
  };

  const getHoverStyle = () => ({
    filter: "none",
    transform: "scale(1, 1) rotate(0deg) !important",
    transition: "all 0.35s",
  });

  const getHoverShadowStyle = () => ({
    content: "",
    position: "absolute",
    zIndex: -1,
    transform: "rotate(0deg)",
    height: "90%",
    width: "90%",
    bottom: "0%",
    right: "5%",
    boxShadow: "0 1rem 3rem rgba(0,0,0,0.2)",
    transition: "all 0.35s",
  });

  const wrapperStyle = {
    width: "100%",
    textAlign: "center",
    position: "relative",
  };

  useEffect(() => {
    // Add CSS for polaroid stack animation
    const style = document.createElement("style");
    style.textContent = `
      .item {
        display: inline-block;
        transform: scale(0.8, 0.8) rotate(5deg);
      }

      .item .polaroid:before {
        content: '';
        position: absolute;
        z-index: -1;
        transform: rotate(6deg);
        height: 20%;
        width: 47%;
        bottom: 30px;
        right: 12px;
        box-shadow: 0 2.1rem 2rem rgba(0,0,0,0.4);
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div style={wrapperStyle}>
      {/* Full-width ribbon line that breaks out of container */}
      <div
        style={{
          position: "relative",
          width: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          overflowX: "hidden",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "2px",
            backgroundColor: "black",
          }}
        />
      </div>

      {/* Polaroid container with normal padding */}
      <div
        style={{
          padding: "0 2rem",
          marginTop: "-3rem",
        }}
      >
        {displayedImages.map((image, index) => (
          <div
            key={index}
            className="item"
            style={{
              ...getItemStyle(),
              marginTop: getMarginTop(index),
            }}
          >
            <div className="polaroid" style={getPolaroidStyle()}>
              <div
                style={{
                  position: "absolute",
                  top: "10px",
                  left: "0px",
                  zIndex: 10,
                }}
              >
                <Grommet />
              </div>
              <div
                style={{
                  position: "absolute",
                  top: "8px",
                  left: "-55px",
                  zIndex: 10,
                  transform: "rotate(-20deg)",
                }}
              >
                <img
                  src={ribbonImage}
                  alt="Ribbon"
                  loading="lazy"
                  decoding="async"
                  style={{
                    width: "120px",
                    height: "auto",
                  }}
                />
              </div>
              <img
                src={image}
                alt={`Wedding photo ${index + 1}`}
                loading="lazy"
                decoding="async"
                style={getImageStyle()}
                onLoad={(e) => handleImageLoad(index, e)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RibbonDivider;
